var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C15.866 5 19 8.13401 19 12C19 12.2534 18.9862 12.5036 18.96 12.75H17.4473C17.4807 12.5047 17.5 12.2545 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 12.2545 6.51927 12.5047 6.55273 12.75H5.04004C5.01379 12.5036 5 12.2534 5 12C5 8.13401 8.13401 5 12 5Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.25L19.0771 17.2539C19.4551 17.2925 19.75 17.6118 19.75 18C19.75 18.3882 19.4551 18.7075 19.0771 18.7461L19 18.75H1C0.585786 18.75 0.25 18.4142 0.25 18C0.25 17.5858 0.585786 17.25 1 17.25H19Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20.25L23.0771 20.2539C23.4551 20.2925 23.75 20.6118 23.75 21C23.75 21.3882 23.4551 21.7075 23.0771 21.7461L23 21.75H5C4.58579 21.75 4.25 21.4142 4.25 21C4.25 20.5858 4.58579 20.25 5 20.25H23Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.25L23.0771 14.2539C23.4551 14.2925 23.75 14.6118 23.75 15C23.75 15.3882 23.4551 15.7075 23.0771 15.7461L23 15.75H5C4.58579 15.75 4.25 15.4142 4.25 15C4.25 14.5858 4.58579 14.25 5 14.25H23Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaze);
export default __webpack_public_path__ + "static/media/Haze.724078c4262aace198e5ac2174decc75.svg";
export { ForwardRef as ReactComponent };